var _path, _path2, _g, _path3, _g2, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3251_164176)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.499 12.9239C26.499 12.895 26.499 12.8664 26.499 12.8375C26.499 5.74773 20.7346 0.000610352 13.624 0.000610352C6.51343 0.000610352 0.75 5.74723 0.75 12.837C0.75 12.8641 0.75 12.8913 0.75 12.9187V14.1637C0.75 21.2532 6.51443 27.0004 13.625 27.0004C20.7356 27.0004 26.499 21.253 26.499 14.1635V12.9239Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3251_164176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.499 12.9233C26.499 12.8944 26.499 12.8658 26.499 12.8369C26.499 5.74712 20.7346 0 13.624 0C6.51343 0 0.75 5.74662 0.75 12.8364C0.75 12.8635 0.75 12.8907 0.75 12.9181V14.1631C0.75 21.2526 6.51443 26.9998 13.625 26.9998C20.7356 26.9998 26.499 21.2524 26.499 14.1629V12.9233Z",
    fill: "#B96400"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3251_164176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 10.75,
    width: 1,
    height: 16.25,
    fill: "#6D6D6D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5979 22.9197C11.0907 22.9155 8.67438 21.9831 6.81766 20.3032C4.96094 18.6233 3.79614 16.3158 3.5492 13.8281C3.30226 11.3405 3.99077 8.85007 5.4812 6.83991C6.97162 4.82974 9.15772 3.44312 11.6155 2.949C14.0732 2.45488 16.6274 2.88848 18.7827 4.16569C20.938 5.4429 22.5407 7.47269 23.2799 9.86136C24.0192 12.25 23.8423 14.8273 22.7836 17.0933C21.7249 19.3593 19.8598 21.1525 17.5502 22.1251C16.2997 22.6523 14.9555 22.9226 13.5979 22.9197Z",
    fill: "url(#paint0_linear_3251_164176)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3251_164176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8127 8.00003C11.2624 8.00003 10.8163 8.4442 10.8163 8.99244C10.8163 9.4541 11.1329 9.84155 11.5613 9.95268L10.5424 12.3055C11.0001 12.3884 11.3469 12.7875 11.3469 13.2675C11.3469 13.8075 10.9078 14.2456 10.3658 14.2456C9.8238 14.2456 9.38473 13.8075 9.38473 13.2675C9.38473 12.8835 9.6068 12.5518 9.92977 12.3916L8.46486 10.1168C8.69569 9.94967 8.84598 9.67917 8.84598 9.37292C8.84598 8.86485 8.43332 8.4523 7.92345 8.4523C7.41352 8.4523 7 8.86494 7 9.37292C7 9.88098 7.41352 10.2927 7.92339 10.2927C7.94455 10.2927 7.96571 10.2923 7.98647 10.291L9.19461 16.8094H18.3046L19.5135 10.291C19.5343 10.2923 19.5555 10.2928 19.5766 10.2928C20.0865 10.2928 20.5 9.88098 20.5 9.37295C20.5 8.86488 20.0865 8.45233 19.5766 8.45233C19.0667 8.45233 18.6532 8.86497 18.6532 9.37295C18.6532 9.68086 18.8056 9.95263 19.0387 10.1195L17.5784 12.4034C17.8891 12.5676 18.1009 12.8927 18.1009 13.2675C18.1009 13.8075 17.6619 14.2457 17.1199 14.2457C16.5779 14.2457 16.1388 13.8075 16.1388 13.2675C16.1388 12.7762 16.5021 12.3696 16.9757 12.3001L15.9739 9.95891C16.4142 9.8562 16.7424 9.46251 16.7424 8.99244C16.7424 8.44414 16.2963 8.00003 15.746 8.00003C15.1957 8.00003 14.7496 8.4442 14.7496 8.99244C14.7496 9.41737 15.0179 9.77967 15.3946 9.92124L14.1109 12.1028C14.5324 12.2326 14.8388 12.6229 14.8388 13.0853C14.8388 13.6538 14.376 14.1146 13.8055 14.1146C13.235 14.1146 12.7731 13.6538 12.7731 13.0853C12.7731 12.65 13.0441 12.2784 13.4271 12.1279L12.1551 9.9248C12.5366 9.78567 12.8091 9.42079 12.8091 8.99241C12.8091 8.44411 12.363 8 11.8127 8L11.8127 8.00003ZM9.19377 17.346C8.50251 17.454 8.53474 18.4901 9.3145 18.4901H9.50639L9.50824 18.5H17.992L17.9938 18.4901H18.2137C18.9642 18.4901 19.0174 17.4584 18.338 17.346H9.19374L9.19377 17.346Z",
    fill: "url(#paint1_linear_3251_164176)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6244 3.21198C16.0073 3.21609 18.3038 4.10247 20.0685 5.69919C21.8331 7.29592 22.94 9.48918 23.1746 11.8536C23.4091 14.2179 22.7546 16.5849 21.3379 18.4954C19.9213 20.4058 17.8434 21.7236 15.5074 22.1931C13.1715 22.6626 10.7438 22.2504 8.69544 21.0363C6.64705 19.8223 5.12389 17.893 4.4214 15.6227C3.71892 13.3523 3.88717 10.9028 4.89354 8.74914C5.8999 6.59549 7.67264 4.89125 9.86791 3.96697C11.0564 3.46586 12.334 3.20907 13.6244 3.21198ZM13.6244 2.21072C10.9925 2.21483 8.45595 3.19339 6.50674 4.95659C4.55754 6.7198 3.33461 9.14196 3.07517 11.7533C2.81573 14.3646 3.53827 16.9789 5.10264 19.0891C6.66701 21.1993 8.9617 22.6551 11.5416 23.1739C14.1215 23.6928 16.8028 23.2378 19.0653 21.8972C21.3278 20.5566 23.0102 18.4259 23.7864 15.9186C24.5625 13.4112 24.3769 10.7057 23.2657 8.32703C22.1544 5.94832 20.1967 4.0659 17.7722 3.0449C16.4599 2.49145 15.0492 2.20772 13.6244 2.21072Z",
    fill: "url(#paint2_linear_3251_164176)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6245 2.2107C16.2564 2.21481 18.7929 3.19337 20.7421 4.95657C22.6913 6.71978 23.9142 9.14194 24.1737 11.7532C24.4331 14.3646 23.7106 16.9789 22.1462 19.0891C20.5819 21.1993 18.2872 22.655 15.7073 23.1739C13.1273 23.6927 10.4461 23.2377 8.1836 21.8972C5.9211 20.5566 4.23861 18.4259 3.4625 15.9185C2.68638 13.4111 2.87195 10.7057 3.98321 8.32701C5.09447 5.94831 7.05221 4.06589 9.47669 3.04488C10.7889 2.49139 12.1997 2.20766 13.6245 2.2107ZM13.6245 0C6.51393 0 0.75 5.74712 0.75 12.8369C0.75 19.9267 6.51443 25.6735 13.625 25.6735C20.7356 25.6735 26.499 19.9264 26.499 12.8369C26.499 5.74737 20.7351 0 13.6245 0Z",
    fill: "url(#paint3_linear_3251_164176)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3251_164176",
    x: 7,
    y: 7.75,
    width: 13.5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.175 0 0 0 0 0.175 0 0 0 0 0.175 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3251_164176"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9625 0 0 0 0 0.9625 0 0 0 0 0.9625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3251_164176",
    result: "effect2_dropShadow_3251_164176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3251_164176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3251_164176",
    x1: 13.5979,
    y1: 24.0106,
    x2: 13.5979,
    y2: 3.75974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3251_164176",
    x1: 13.75,
    y1: 18.4993,
    x2: 13.75,
    y2: 8.00067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3251_164176",
    x1: 13.6244,
    y1: 2.47118,
    x2: 13.6244,
    y2: 23.7233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3251_164176",
    x1: 13.6245,
    y1: 25.9337,
    x2: 13.6245,
    y2: 0.260215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7B7B7B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3251_164176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.75,
    height: 27,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.71cc294f4f8600ff3dc3601242974733.svg";
export { ForwardRef as ReactComponent };